import { render, staticRenderFns } from "./FirstScreenSliderNews.vue?vue&type=template&id=7e0cb55a"
import script from "./FirstScreenSliderNews.vue?vue&type=script&lang=js"
export * from "./FirstScreenSliderNews.vue?vue&type=script&lang=js"
import style0 from "./FirstScreenSliderNews.vue?vue&type=style&index=0&id=7e0cb55a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports